import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-fill-tick-round-icon',
  templateUrl: './lib-fill-tick-round-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibFillTickRoundIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
